import { render, staticRenderFns } from "./marketTaskTemplate.vue?vue&type=template&id=a0982dc8&scoped=true&"
import script from "./marketTaskTemplate.vue?vue&type=script&lang=js&"
export * from "./marketTaskTemplate.vue?vue&type=script&lang=js&"
import style0 from "./marketTaskTemplate.vue?vue&type=style&index=0&id=a0982dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0982dc8",
  null
  
)

export default component.exports